import posthog from "posthog-js";
import Button from "../components/button";
import { useCallback, useRef, useState } from "react";
import TextField from "../components/textField";
import BankNumberField from "../components/bankNumberField";
import { ShowErrorMsg, ShowSuccessMsg } from "../utils/usePopupMessage";

interface UserDetailsProps {
  setStep: React.Dispatch<React.SetStateAction<number>>;
  invitationCode: string;
  setInvitationCode: React.Dispatch<React.SetStateAction<string>>;
  verifiedToken: string | null;
  captchaToken: string | null;
  setCaptchaToken: React.Dispatch<React.SetStateAction<string | null>>;
  setVerifiedToken: React.Dispatch<React.SetStateAction<string | null>>;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const UserDetails = ({
  setStep,
  invitationCode,
  setInvitationCode,
  captchaToken,
  setCaptchaToken,
  verifiedToken,
  setVerifiedToken,
  loading,
  setLoading,
}: UserDetailsProps) => {
  const [account, setAccount] = useState("");
  const [bankDigits, setBankDigits] = useState(["", "", "", ""]);
  const digitRefs = useRef<(HTMLInputElement | null)[]>([]);

  const handleDigitChange = (value: string, index: number) => {
    if (!/^\d?$/.test(value)) return;

    const newDigits = [...bankDigits];
    newDigits[index] = value;
    setBankDigits(newDigits);

    if (value && index < digitRefs.current.length - 1) {
      digitRefs.current[index + 1]?.focus();
    }

    const allDigitsFilled = newDigits.every((digit) => digit.trim() !== "");

    if (allDigitsFilled) {
      posthog.capture("BankTextField", {
        field_name: "bank",
        input_value: newDigits.join(""),
        timestamp: new Date().toISOString(),
      });
    }
  };

  // const handleAccountFocus = () => {
  //   posthog.capture("AccountTextField_Focused", {
  //     field_name: "invitation_code",
  //     timestamp: new Date().toISOString(),
  //   });
  // };

  // const handleAccountBlur = () => {
  //   posthog.capture("AccountTextField_Blurred", {
  //     field_name: "invitation_code",
  //     input_length: account.length,
  //     timestamp: new Date().toISOString(),
  //   });
  // };

  // const handleBankFocus = () => {
  //   posthog.capture("BankTextField_Focused", {
  //     field_name: "invitation_code",
  //     timestamp: new Date().toISOString(),
  //   });
  // };

  // const handleBankBlur = () => {
  //   posthog.capture("BankTextField_Blurred", {
  //     field_name: "invitation_code",
  //     input_length: account.length,
  //     timestamp: new Date().toISOString(),
  //   });
  // };

  const handleSubmit = async () => {
    setLoading(true);
    const bankCard = bankDigits.join("");

    posthog.capture("GetInviteBonus_Button_Click", {
      button_location: "GetInviteBonusPage",
      is_formal_action: true,
      timestamp: new Date().toISOString(),
    });

    await new Promise((resolve) => setTimeout(resolve, 2000)); // adjust as needed

    //api call
    try {
      const requestParam = {
        InviteCode: invitationCode,
        Account: account,
        BankCard: bankCard,
        VerifyCode: captchaToken,
        Token: verifiedToken,
        DistinctId: posthog.get_distinct_id(),
      };

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Promotion/GetInviteBonus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestParam),
        }
      );

      const result = await response.json();

      if (result) {
        setAccount("");
        setBankDigits(["", "", "", ""]);

        if (result.code === 200) {
          ShowSuccessMsg(`Tiền thưởng mời của bạn là ${result.message}`);
          setStep(1);
          setInvitationCode("");
          setCaptchaToken(null);
          setVerifiedToken(null);
        } else if (response.status === 400) {
          setAccount("");
          setBankDigits(["", "", "", ""]);
        } else {
          ShowErrorMsg(result.message);
        }
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <TextField
          id="account"
          imgSrc={`${process.env.PUBLIC_URL}/img/avatar.png`}
          imgAlt="J88 Logo"
          label="Tên tài khoản của bạn"
          type="text"
          placeholder="Vui Lòng Nhập Tên Tài Khoản"
          className="lg:w-2/3 w-full mb-4"
          value={account}
          onChange={(e) => {
            setAccount(e.target.value);
          }}
          onBlur={useCallback((e: React.FocusEvent<HTMLInputElement>) => {
            posthog.capture("AccountTextField", {
              field_name: "account",
              input_value: e.target.value,
              timestamp: new Date().toISOString(),
            });
          }, [])}
          required
        />
        <BankNumberField
          imgSrc={`${process.env.PUBLIC_URL}/img/bank.png`}
          imgAlt="bank Logo"
          label="Xác nhận 4 số cuối tài khoản ngân hàng"
          bankDigits={bankDigits}
          digitRefs={digitRefs}
          handleDigitChange={handleDigitChange}
          required
        />
        <div className="flex justify-center">
          <Button type="submit" text={"XÁC NHẬN"} disabled={loading} />
        </div>
      </form>
    </>
  );
};

export default UserDetails;
